'use client';

import React, { useEffect, useMemo, useRef, useState } from 'react';
import ds from '@/styles/ds/ds.module.scss';
import { useModalStoreActions, useUser } from '@/store';
import Input_FirstName from '@/components/Inputs/Input_FirstName/Input_FirstName';
import Input_LastName from '@/components/Inputs/Input_LastName/Input_LastName';
import Input_Primary from '@/components/Inputs/Input_Primary/Input_Primary';
import Input_Address1 from '@/components/Inputs/Input_Address1/Input_Address1';
import Input_Country from '@/components/Inputs/Input_Country/Input_Country';
// import Input_PostalCode from '@/components/Inputs/Input_PostalCode/Input_PostalCode';
import Input_City from '@/components/Inputs/Input_City/Input_City';
import Input_PhoneNumber from '@/components/Inputs/Input_PhoneNumber/Input_PhoneNumber';
import Input_CheckBox from '@/components/Inputs/Input_CheckBox/Input_CheckBox';
import Loader_Form_Primary from '@/components/Loaders/Loader_Form_Primary/Loader_Form_Primary';
import { useUpdateUser } from '@/backend/user/post-update-user';
import { useUpdateKYCLevel1 } from '@/backend/onboarding/post-update-kyc-level-1';
import { useUpdateStep } from '@/backend/onboarding/post-update-step';
import { countryCodeWithoutZipCode, zipCodeRegex } from '@/constants';
import { useOnboardingStoreActions } from '@/features/Onboarding/store';
import Input_DateOfBirth from '@/components/Inputs/Input_DateOfBirth/Input_DateOfBirth';
import { icons } from '@/Icons';
import { useGetAllCountries } from '@/backend/common/get-all-countries';

export interface UserInfo {
	firstName: string;
	lastName: string;
	dateOfBirth: string;
	countryCode: string;
	address: string;
	city: string;
	postalCode: string;
	attestation: boolean;
	phoneCode?: string;
	phone?: string;
}

export enum VerificationLevel1FormIds {
	FirstName = 'firstName',
	LastName = 'lastName',
	DateOfBirth = 'dateOfBirth',
	PhoneNumber = 'phoneNumber',
	PhoneCode = 'phoneCode',
	Address = 'address',
	Country = 'country',
	City = 'city',
	PostalCode = 'postalCode',
	Attestation = 'attestation',
	Day = 'day',
	Month = 'month',
	Year = 'year',
}

interface VerificationLevel1Props {
	isOnboarding?: boolean;
}

const VerificationLevel1 = ({ isOnboarding }: VerificationLevel1Props) => {
	const [firstName, setFirstName] = useState('');
	const [lastName, setLastName] = useState('');
	const [day, setDay] = useState('');
	const [month, setMonth] = useState('');
	const [year, setYear] = useState('');
	const [phoneNumber, setPhoneNumber] = useState('');
	const [phoneCode, setPhoneCode] = useState('');
	const [address, setAddress] = useState('');
	const [country, setCountry] = useState('');
	const [city, setCity] = useState('');
	const [postalCode, setPostalCode] = useState('');
	const [attestation, setAttestation] = useState(false);
	const [selectedDial, setSelectedDial] = useState<string>('');

	const { data: countries, getAllCountries } = useGetAllCountries();
	useEffect(() => {
		getAllCountries();
	}, []);

	const user = useUser();
	const [formError, setFormError] = useState<string | null>(null);
	const { setOnboardingStep } = useOnboardingStoreActions();
	const { updateUser, loading: loading_updateUser } = useUpdateUser();
	const { updateKYCLevel1, loading: loading_updateKYCLevel1 } =
		useUpdateKYCLevel1();
	const { updateStep, loading: loading_updateStep } = useUpdateStep();
	const { setModalStatus } = useModalStoreActions();

	const isLoading = useMemo(() => {
		return loading_updateUser || loading_updateKYCLevel1 || loading_updateStep;
	}, [loading_updateUser, loading_updateKYCLevel1, loading_updateStep]);

	const convertToISODate = (dob: string): string => {
		const [day, month, year] = dob.split('/');
		if (!day || !month || !year) return '';
		return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
	};

	const isValidDate = (day: number, month: number, year: number) => {
		const date = new Date(year, month - 1, day);
		return (
			date.getFullYear() === year &&
			date.getMonth() === month - 1 &&
			date.getDate() === day
		);
	};

	const isAtLeast18 = (day: number, month: number, year: number) => {
		const today = new Date();
		const dob = new Date(year, month - 1, day);
		const age = today.getFullYear() - dob.getFullYear();
		const m = today.getMonth() - dob.getMonth();
		if (m < 0 || (m === 0 && today.getDate() < dob.getDate())) {
			return age - 1 >= 18;
		}
		return age >= 18;
	};
	/* -------------------------------------------------------------------------- */
	const formRef = useRef<HTMLFormElement | null>(null);
	const [canSubmit, setCanSubmit] = useState(false);

	// useEffect(() => {
	// 	if (!user || !countries) return;

	// 	const form = formRef.current;
	// 	if (!form) return;

	// 	const required = [
	// 		VerificationLevel1FormIds.FirstName,
	// 		VerificationLevel1FormIds.LastName,
	// 		VerificationLevel1FormIds.Day,
	// 		VerificationLevel1FormIds.Month,
	// 		VerificationLevel1FormIds.Year,
	// 		VerificationLevel1FormIds.Address,
	// 		VerificationLevel1FormIds.Country,
	// 		VerificationLevel1FormIds.City,
	// 		VerificationLevel1FormIds.Attestation,
	// 	];

	// 	const handleInput = () => {
	// 		const allFilled = required.every((field) => {
	// 			const el = form.elements.namedItem(field) as
	// 				| HTMLInputElement
	// 				| HTMLSelectElement;
	// 			return el?.type === 'checkbox'
	// 				? (el as HTMLInputElement).checked
	// 				: el?.value.trim() !== '';
	// 		});
	// 		setCanSubmit(allFilled);
	// 	};

	// 	// normal typing / click
	// 	form.addEventListener('input', handleInput);
	// 	form.addEventListener('change', handleInput);

	// 	// detect autofill
	// 	const observer = new MutationObserver(() => {
	// 		handleInput();
	// 	});

	// 	observer.observe(form, {
	// 		childList: true,
	// 		subtree: true,
	// 		attributes: true,
	// 	});

	// 	// force check once after load
	// 	handleInput();

	// 	return () => {
	// 		form.removeEventListener('input', handleInput);
	// 		form.removeEventListener('change', handleInput);
	// 		observer.disconnect();
	// 	};
	// }, [user, countries]);

	// useEffect(() => {
	// 	if (!user || !countries) return;

	// 	const form = formRef.current;
	// 	if (!form) return;

	// 	const required = [
	// 		VerificationLevel1FormIds.FirstName,
	// 		VerificationLevel1FormIds.LastName,
	// 		VerificationLevel1FormIds.Day,
	// 		VerificationLevel1FormIds.Month,
	// 		VerificationLevel1FormIds.Year,
	// 		VerificationLevel1FormIds.Address,
	// 		VerificationLevel1FormIds.Country,
	// 		VerificationLevel1FormIds.City,
	// 		VerificationLevel1FormIds.Attestation,
	// 	];

	// 	const handleInput = () => {
	// 		const allFilled = required.every((field) => {
	// 			const el = form.elements.namedItem(field) as
	// 				| HTMLInputElement
	// 				| HTMLSelectElement;
	// 			return el?.type === 'checkbox'
	// 				? (el as HTMLInputElement).checked
	// 				: el?.value.trim() !== '';
	// 		});
	// 		setCanSubmit(allFilled);
	// 	};

	// 	form.addEventListener('input', handleInput);
	// 	form.addEventListener('change', handleInput);

	// 	const observer = new MutationObserver(handleInput);
	// 	observer.observe(form, {
	// 		childList: true,
	// 		subtree: true,
	// 		attributes: true,
	// 	});

	// 	// 👇 Force handleInput manually after small delay to catch Chrome autofill
	// 	const timeout = setTimeout(() => {
	// 		handleInput();
	// 	}, 300);

	// 	return () => {
	// 		form.removeEventListener('input', handleInput);
	// 		form.removeEventListener('change', handleInput);
	// 		observer.disconnect();
	// 		clearTimeout(timeout);
	// 	};
	// }, [user, countries]);

	useEffect(() => {
		if (!user || !countries) return;

		const form = formRef.current;
		if (!form) return;

		const required = [
			VerificationLevel1FormIds.FirstName,
			VerificationLevel1FormIds.LastName,
			VerificationLevel1FormIds.Day,
			VerificationLevel1FormIds.Month,
			VerificationLevel1FormIds.Year,
			VerificationLevel1FormIds.Address,
			VerificationLevel1FormIds.Country,
			VerificationLevel1FormIds.City,
			VerificationLevel1FormIds.Attestation,
		];

		const allFieldsFilled = required.every((field) => {
			const el = form.elements.namedItem(field) as
				| HTMLInputElement
				| HTMLSelectElement;
			return el?.type === 'checkbox'
				? (el as HTMLInputElement).checked
				: el?.value.trim() !== '';
		});

		setCanSubmit(allFieldsFilled);
	}, [
		firstName,
		lastName,
		day,
		month,
		year,
		attestation,
		address,
		country,
		city,
		postalCode,
	]);

	/* -------------------------------------------------------------------------- */

	const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
		e.preventDefault();
		setFormError(null);

		const formData = new FormData(e.currentTarget);
		const formValues: Record<string, string> = {};

		formData.forEach((value, key) => {
			formValues[key] =
				key === VerificationLevel1FormIds.Attestation ? 'on' : value.toString();
		});

		const elementError = (name: string) => {
			const el = document.querySelector<HTMLInputElement>(`[name="${name}"]`);
			el?.classList.add('!border-tokens-negative');
		};

		const elementSuccess = (name: string) => {
			const el = document.querySelector<HTMLInputElement>(`[name="${name}"]`);
			el?.classList.remove('!border-tokens-negative');
		};

		// --- First Name Validation ---
		const firstName = formValues[VerificationLevel1FormIds.FirstName]?.trim();
		if (!firstName || firstName.length < 2) {
			elementError(VerificationLevel1FormIds.FirstName);
			setFormError('First name must be at least 2 characters.');
			return;
		} else {
			elementSuccess(VerificationLevel1FormIds.FirstName);
		}

		// --- Last Name Validation ---
		const lastName = formValues[VerificationLevel1FormIds.LastName]?.trim();
		if (!lastName || lastName.length < 2) {
			elementError(VerificationLevel1FormIds.LastName);
			setFormError('Last name must be at least 2 characters.');
			return;
		} else {
			elementSuccess(VerificationLevel1FormIds.LastName);
		}

		// --- DOB Validation ---
		const day = parseInt(formValues['day']);
		const month = parseInt(formValues['month']);
		const year = parseInt(formValues['year']);

		if (!isValidDate(day, month, year)) {
			setFormError('Invalid date of birth.');
			return;
		}
		if (!isAtLeast18(day, month, year)) {
			setFormError('You must be at least 18 years old.');
			return;
		}

		// --- Phone + PhoneCode Validation ---
		const phone = formValues[VerificationLevel1FormIds.PhoneNumber]?.trim();
		const phoneCode = formValues[VerificationLevel1FormIds.PhoneCode]?.trim();

		if ((phone && !phoneCode) || (!phone && phoneCode)) {
			setFormError(
				'Phone number and phone code must both be filled or both empty.'
			);
			return;
		}
		if (phone && !/^\d{7,15}$/.test(phone)) {
			setFormError('Phone must be 7-15 digits.');
			return;
		}

		// --- Postal Code Regex FIRST ---
		const country = formValues[VerificationLevel1FormIds.Country];
		const postalCode = formValues[VerificationLevel1FormIds.PostalCode];
		const zipRegex = zipCodeRegex[country];
		const zipRequired = !countryCodeWithoutZipCode.includes(country);

		if (zipRequired && zipRegex && postalCode && !zipRegex.test(postalCode)) {
			elementError(VerificationLevel1FormIds.PostalCode);
			setFormError('Invalid postal code for selected country.');
			return;
		} else {
			elementSuccess(VerificationLevel1FormIds.PostalCode);
		}

		// --- Remaining Field Validations (except postal code already done) ---
		const validations: Record<string, (value: string) => string | null> = {
			[VerificationLevel1FormIds.Address]: (v) =>
				v.trim().length >= 5 ? null : 'Address must be at least 5 characters.',
			[VerificationLevel1FormIds.City]: (v) =>
				v.trim().length >= 2 ? null : 'City must be at least 2 characters.',
			[VerificationLevel1FormIds.Country]: (v) =>
				v.trim() !== '' ? null : 'Country is required.',
			[VerificationLevel1FormIds.Attestation]: (v) =>
				v === 'on' ? null : 'You must accept the attestation.',
		};

		for (const [key, validate] of Object.entries(validations)) {
			if (key === VerificationLevel1FormIds.PostalCode) continue;
			const value = formValues[key] || '';
			const errorMessage = validate(value);
			if (errorMessage) {
				elementError(key);
				setFormError(errorMessage);
				return;
			} else {
				elementSuccess(key);
			}
		}

		// --- Build Payload ---
		const body: UserInfo = {
			firstName,
			lastName,
			dateOfBirth: `${year}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}`,
			phone: phone || '',
			phoneCode: phoneCode || '',
			address: formValues[VerificationLevel1FormIds.Address],
			countryCode: country,
			city: formValues[VerificationLevel1FormIds.City],
			postalCode,
			attestation: true,
		};

		if (isOnboarding) {
			const filteredBody = Object.fromEntries(
				Object.entries(body).filter(([_, value]) => value !== '')
			) as UserInfo;

			await updateKYCLevel1(filteredBody);

			// await updateKYCLevel1(fakePayload);
		} else {
			const body: any = {
				firstName,
				lastName,
				dateOfBirth: `${year}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}`,
				phone: phone || '',
				phoneCode: phoneCode || '',

				address: {
					address: formValues[VerificationLevel1FormIds.Address],
					countryCode: country,
					city: formValues[VerificationLevel1FormIds.City],
					zipCode: postalCode,
				},

				attestation: user?.moreDetails?.attestation || false,
			};

			await updateUser({ body });
		}
	};

	return (
		<form
			ref={formRef}
			onSubmit={handleSubmit}
			className="my-auto gap-4 h-full overflow-hidden"
		>
			{isLoading && (
				<div className="w-full h-full left-0 top-0 absolute z-10 backdrop-blur-sm grid place-items-center">
					<Loader_Form_Primary divProps={{ className: '!w-[25%] !h-[25%]' }} />
				</div>
			)}
			{isOnboarding ? (
				<p className={`${ds.sectionHeader} flex items-center gap-3`}>
					<span className="w-6 h-6 relative text-dove-white-o-70 ">
						<icons.verification />
					</span>
					Verify Level 1
				</p>
			) : null}
			<div
				className={`grid my-auto h-[65vh] py-[20px] ${isLoading ? 'opacity-0' : ''}`}
				style={{ gridTemplateRows: '1fr min-content' }}
			>
				<div className="relative  h-full">
					<div className={`overflow-scroll h-full absolute ${ds.form_primary}`}>
						<div className="flex gap-2 items-end">
							<Input_FirstName
								firstName={firstName}
								setFirstName={setFirstName}
							/>
							<Input_LastName lastName={lastName} setLastName={setLastName} />
						</div>

						<div className="flex gap-2 items-end">
							<Input_DateOfBirth
								day={day}
								setDay={setDay}
								month={month}
								setMonth={setMonth}
								year={year}
								setYear={setYear}
							/>
						</div>

						<div className="flex gap-2 items-end">
							<Input_PhoneNumber
								phoneNumber={phoneNumber}
								setPhoneNumber={setPhoneNumber}
								selectedDial={selectedDial}
								setSelectedDial={setSelectedDial}
							/>
						</div>

						<div className="flex gap-2 items-end">
							<Input_Address1 address={address} setAddress={setAddress} />
						</div>

						<div className="flex gap-2 items-end">
							<Input_City city={city} setCity={setCity} />
							<Input_Country
								countries={countries}
								country={country}
								setCountry={setCountry}
								postalCode={postalCode}
								setPostalCode={setPostalCode}
							/>

							{/* <Input_PostalCode /> */}
						</div>

						{formError && (
							<p className="text-xs text-tokens-negative">{formError}</p>
						)}

						<div className="flex items-start gap-2 mt-4">
							<Input_CheckBox
								attestation={attestation}
								setAttestation={setAttestation}
							/>
						</div>
						{!isOnboarding ? (
							<div className="flex gap-3 pt-4 sticky bottom-0">
								<button
									disabled={isLoading || !canSubmit}
									aria-label="Accept and Continue"
									type="submit"
									className={`${ds.primary} ${ds.purpleWhite} h-10 !px-4 max-w-[150px]`}
								>
									Submit
								</button>
								<button
									aria-label="Skip"
									type="button"
									onClick={(e) => {
										e.preventDefault();
										setModalStatus(null);
									}}
									className={`${ds.tertiary} ${ds.purpleWhite} h-10 !px-4 max-w-[150px]`}
								>
									close
								</button>
							</div>
						) : null}
						<p className="text-xs text-dove-white-o-70 mt-4">
							We reserve the right, at any time, to ask you for KYC
							documentation if we deem it necessary in order to determine your
							identity, location or age, or for any other purpose. We reserve
							the right to restrict your ability to access any or all Services
							or to make payments or withdrawals until your identity has been
							determined to our satisfaction, at our sole discretion. <br />{' '}
							<br /> You agree to provide accurate and truthful information
							during the Know Your Customer (KYC) process.
							<br /> <br /> If you submit false information during KYC Level
							1—including but not limited to a fake name, country, or
							address—and are later required to complete KYC Level 2 (e.g., to
							verify your identity for a large withdrawal or jackpot win), and
							your information fails to match or cannot be verified, we reserve
							the right to withhold any deposits or winnings, cancel your
							account without refund, and/or report the incident to relevant
							authorities, where applicable.
							<br /> <br /> Providing false information violates our Terms of
							Service and may result in permanent account termination.
						</p>
					</div>
				</div>
				{isOnboarding ? (
					<div className="flex flex-col gap-2 mt-4 sticky bottom-0">
						<button
							disabled={isLoading || !canSubmit}
							aria-label="Accept and Continue"
							type="submit"
							className={`${ds.primary} ${ds.purpleWhite} h-10 !px-4`}
						>
							Submit
						</button>
						<button
							aria-label="Skip"
							type="button"
							onClick={(e) => {
								e.preventDefault();
								updateStep(user?.currentOnboardingStep);
							}}
							className=" w-min mx-auto motion-safe:hover:underline underline-offset-2"
						>
							Skip
						</button>
					</div>
				) : null}
			</div>
		</form>
	);
};

export default VerificationLevel1;
